import { render } from "./AboutListSlider.vue?vue&type=template&id=3f29ab25"
import script from "./AboutListSlider.vue?vue&type=script&lang=js"
export * from "./AboutListSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__